var iframely = window.iframely = window.iframely || {};
iframely.config = iframely.config || {};

module.exports = iframely;